import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { Zigzag } from "./Doodles";

const facts = [
  { k: "Ages", v: "3–8" },
  { k: "Genre", v: "Funny adventure" },
  { k: "Author", v: "6 years old when written" },
];

export const BookSection = () => (
  <section id="book" className="relative bg-cream text-ink py-28 sm:py-40 overflow-hidden">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-center">
      <Reveal className="lg:col-span-5 order-2 lg:order-1">
        <div className="relative">
          <motion.div
            whileHover={{ rotate: 0, scale: 1.02 }}
            className="relative rotate-[-4deg] rounded-[2rem] overflow-hidden border-2 border-ink shadow-[10px_10px_0_#12303B] bg-white"
          >
            <img src="/img/book-cover.jpg" alt="The Party Pet Shop cover artwork" className="w-full aspect-square object-cover" />
          </motion.div>
          <Zigzag className="absolute -bottom-12 right-0 w-40 text-coral" />
        </div>
      </Reveal>
      <div className="lg:col-span-7 order-1 lg:order-2">
        <Reveal><p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-coral">The book</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-4 font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            Not your average <span className="text-coral">pet shop.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-base sm:text-lg leading-relaxed text-ink/80 max-w-xl">
            The Party Pet Shop is a funny story written by 6 year old Reuben Ackerman. It shares the adventures of
            not your average pet shop. A light-hearted read that takes you on a journey.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-6 font-hand text-4xl sm:text-5xl text-ink">Will the mouse save the day?!</p>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-xl">
            {facts.map((f) => (
              <div key={f.k} data-testid={`book-fact-${f.k.toLowerCase().replace(/\s/g, "-")}`} className="rounded-2xl border-2 border-ink bg-white p-4 hover:-translate-y-1 transition-transform duration-300">
                <p className="text-xs font-bold uppercase tracking-widest text-ink/60">{f.k}</p>
                <p className="mt-1 font-display text-lg sm:text-2xl leading-tight">{f.v}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
